import { practiceAdminMetaAdviceRoomsApi } from './adviceRooms';

export function practiceAdminMetaApi(path: string) {
  return {
    path,
    adviceRooms: () => practiceAdminMetaAdviceRoomsApi(`${path}/client-meeting-rooms`),
  };
}
